import React from "react";
import { Card } from "antd";
import Slider from "react-slick";
import { ForumCard } from "./components";
import { sliderSettings } from "./sliderSettings";

const ForumBox = ({ data, showAll }) => {
  return (
    <>
      <Card
        style={{
          width: "100%",
          borderRadius: 10,
          overflow: "hidden",
          padding: "30px",
          background: "#fff",
        }}
        className="no-border"
      >
        <h3 className="text-lg 2xl:text-xl font-bold">Interesting Forums</h3>
        <div className="hidden lg:block xl:block 2xl:hidden mt-5">
          {showAll ? (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 my-10 justify-items-center">
              {data.map((item, index) => (
                <ForumCard
                  key={index}
                  bgColor={item.bgColor}
                  title={item.name}
                  members={item.members}
                  image={item.image}
                />
              ))}
            </div>
          ) : (
            <Slider {...sliderSettings}>
              {data.map((item, index) => (
                <ForumCard
                  key={index}
                  bgColor={item.bgColor}
                  title={item.name}
                  members={item.members}
                  image={item.image}
                />
              ))}
            </Slider>
          )}
        </div>

        <div className="block lg:hidden 2xl:block mt-5">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 my-10 justify-items-center">
            {data.map((item, index) => (
              <ForumCard
                key={index}
                bgColor={item.bgColor}
                title={item.name}
                members={item.members}
                image={item.image}
              />
            ))}
          </div>
        </div>
      </Card>
    </>
  );
};

export default ForumBox;
